import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  "use strict";

  try {
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) < "u") {
      var o = document.createElement("style");
      o.appendChild(document.createTextNode('.image-tool{--bg-color: #cdd1e0;--front-color: #388ae5;--border-color: #e8e8eb}.image-tool__image{border-radius:3px;overflow:hidden;margin-bottom:10px;padding-bottom:0}.image-tool__image-picture{max-width:100%;vertical-align:bottom;display:block}.image-tool__image-preloader{width:50px;height:50px;border-radius:50%;background-size:cover;margin:auto;position:relative;background-color:var(--bg-color);background-position:center center}.image-tool__image-preloader:after{content:"";position:absolute;z-index:3;width:60px;height:60px;border-radius:50%;border:2px solid var(--bg-color);border-top-color:var(--front-color);left:50%;top:50%;margin-top:-30px;margin-left:-30px;animation:image-preloader-spin 2s infinite linear;box-sizing:border-box}.image-tool__caption{visibility:hidden;position:absolute;bottom:0;left:0;margin-bottom:10px}.image-tool__caption[contentEditable=true][data-placeholder]:before{position:absolute!important;content:attr(data-placeholder);color:#707684;font-weight:400;display:none}.image-tool__caption[contentEditable=true][data-placeholder]:empty:before{display:block}.image-tool__caption[contentEditable=true][data-placeholder]:empty:focus:before{display:none}.image-tool--empty .image-tool__image,.image-tool--empty .image-tool__image-preloader{display:none}.image-tool--empty .image-tool__caption,.image-tool--uploading .image-tool__caption{visibility:hidden!important}.image-tool .cdx-button{display:flex;align-items:center;justify-content:center}.image-tool .cdx-button svg{height:auto;margin:0 6px 0 0}.image-tool--filled .cdx-button,.image-tool--filled .image-tool__image-preloader{display:none}.image-tool--uploading .image-tool__image{min-height:200px;display:flex;border:1px solid var(--border-color);background-color:#fff}.image-tool--uploading .image-tool__image-picture,.image-tool--uploading .cdx-button{display:none}.image-tool--withBorder .image-tool__image{border:1px solid var(--border-color)}.image-tool--withBackground .image-tool__image{padding:15px;background:var(--bg-color)}.image-tool--withBackground .image-tool__image-picture{max-width:60%;margin:0 auto}.image-tool--stretched .image-tool__image-picture{width:100%}.image-tool--caption .image-tool__caption{visibility:visible}.image-tool--caption{padding-bottom:50px}@keyframes image-preloader-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}')), document.head.appendChild(o);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();

var R = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19V19C9.13623 19 8.20435 19 7.46927 18.6955C6.48915 18.2895 5.71046 17.5108 5.30448 16.5307C5 15.7956 5 14.8638 5 13V12C5 9.19108 5 7.78661 5.67412 6.77772C5.96596 6.34096 6.34096 5.96596 6.77772 5.67412C7.78661 5 9.19108 5 12 5H13.5C14.8956 5 15.5933 5 16.1611 5.17224C17.4395 5.56004 18.44 6.56046 18.8278 7.83886C19 8.40666 19 9.10444 19 10.5V10.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 13V16M16 19V16M19 16H16M16 16H13"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6.5 17.5L17.5 6.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.9919 10.5H19.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.9919 19H11.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13L13 5"/></svg>',
    I = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.9919 9.5H19.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.5 5H14.5096"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.625 5H15C17.2091 5 19 6.79086 19 9V9.375"/><path stroke="currentColor" stroke-width="2" d="M9.375 5L9 5C6.79086 5 5 6.79086 5 9V9.375"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.3725 5H9.38207"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 9.5H5.00957"/><path stroke="currentColor" stroke-width="2" d="M9.375 19H9C6.79086 19 5 17.2091 5 15V14.625"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.3725 19H9.38207"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 14.55H5.00957"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 13V16M16 19V16M19 16H16M16 16H13"/></svg>',
    L = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.13968 15.32L8.69058 11.5661C9.02934 11.2036 9.48873 11 9.96774 11C10.4467 11 10.9061 11.2036 11.2449 11.5661L15.3871 16M13.5806 14.0664L15.0132 12.533C15.3519 12.1705 15.8113 11.9668 16.2903 11.9668C16.7693 11.9668 17.2287 12.1705 17.5675 12.533L18.841 13.9634"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.7778 9.33331H13.7867"/></svg>',
    x = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9L20 12L17 15"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 12H20"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 9L4 12L7 15"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 12H10"/></svg>',
    B = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';

function S(C) {
  var _s$classList;

  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var s = document.createElement(C);
  Array.isArray(i) ? (_s$classList = s.classList).add.apply(_s$classList, _toConsumableArray(i)) : i !== null && s.classList.add(i);

  for (var r in a) {
    a.hasOwnProperty(r) && (s[r] = a[r]);
  }

  return s;
}

var _ = /* @__PURE__ */function (C) {
  return C.Empty = "empty", C.Uploading = "uploading", C.Filled = "filled", C;
}(_ || {});

var D = /*#__PURE__*/function () {
  /**
   * @param ui - image tool Ui module
   * @param ui.api - Editor.js API
   * @param ui.config - user config
   * @param ui.onSelectFile - callback for clicks on Select file button
   * @param ui.readOnly - read-only mode flag
   */
  function D(_ref) {
    var i = _ref.api,
        a = _ref.config,
        s = _ref.onSelectFile,
        r = _ref.readOnly;

    _classCallCheck(this, D);

    this.api = i, this.config = a, this.onSelectFile = s, this.readOnly = r, this.nodes = {
      wrapper: S("div", [this.CSS.baseClass, this.CSS.wrapper]),
      imageContainer: S("div", [this.CSS.imageContainer]),
      fileButton: this.createFileButton(),
      imageEl: void 0,
      imagePreloader: S("div", this.CSS.imagePreloader),
      caption: S("div", [this.CSS.input, this.CSS.caption], {
        contentEditable: !this.readOnly
      })
    }, this.nodes.caption.dataset.placeholder = this.config.captionPlaceholder, this.nodes.imageContainer.appendChild(this.nodes.imagePreloader), this.nodes.wrapper.appendChild(this.nodes.imageContainer), this.nodes.wrapper.appendChild(this.nodes.caption), this.nodes.wrapper.appendChild(this.nodes.fileButton);
  }
  /**
   * Apply visual representation of activated tune
   * @param tuneName - one of available tunes {@link Tunes.tunes}
   * @param status - true for enable, false for disable
   */


  _createClass(D, [{
    key: "applyTune",
    value: function applyTune(i, a) {
      this.nodes.wrapper.classList.toggle("".concat(this.CSS.wrapper, "--").concat(i), a);
    }
    /**
     * Renders tool UI
     */

  }, {
    key: "render",
    value: function render() {
      return this.toggleStatus("empty"
      /* Empty */
      ), this.nodes.wrapper;
    }
    /**
     * Shows uploading preloader
     * @param src - preview source
     */

  }, {
    key: "showPreloader",
    value: function showPreloader(i) {
      this.nodes.imagePreloader.style.backgroundImage = "url(".concat(i, ")"), this.toggleStatus("uploading"
      /* Uploading */
      );
    }
    /**
     * Hide uploading preloader
     */

  }, {
    key: "hidePreloader",
    value: function hidePreloader() {
      this.nodes.imagePreloader.style.backgroundImage = "", this.toggleStatus("empty"
      /* Empty */
      );
    }
    /**
     * Shows an image
     * @param url - image source
     */

  }, {
    key: "fillImage",
    value: function fillImage(i) {
      var _this = this;

      var a = /\.mp4$/.test(i) ? "VIDEO" : "IMG",
          s = {
        src: i
      };
      var r = "load";
      a === "VIDEO" && (s.autoplay = !0, s.loop = !0, s.muted = !0, s.playsinline = !0, r = "loadeddata"), this.nodes.imageEl = S(a, this.CSS.imageEl, s), this.nodes.imageEl.addEventListener(r, function () {
        _this.toggleStatus("filled"
        /* Filled */
        ), _this.nodes.imagePreloader !== void 0 && (_this.nodes.imagePreloader.style.backgroundImage = "");
      }), this.nodes.imageContainer.appendChild(this.nodes.imageEl);
    }
    /**
     * Shows caption input
     * @param text - caption content text
     */

  }, {
    key: "fillCaption",
    value: function fillCaption(i) {
      this.nodes.caption !== void 0 && (this.nodes.caption.innerHTML = i);
    }
    /**
     * Changes UI status
     * @param status - see {@link Ui.status} constants
     */

  }, {
    key: "toggleStatus",
    value: function toggleStatus(i) {
      for (var a in _) {
        if (Object.prototype.hasOwnProperty.call(_, a)) {
          var s = _[a];
          this.nodes.wrapper.classList.toggle("".concat(this.CSS.wrapper, "--").concat(s), s === i);
        }
      }
    }
    /**
     * CSS classes
     */

  }, {
    key: "CSS",
    get: function get() {
      return {
        baseClass: this.api.styles.block,
        loading: this.api.styles.loader,
        input: this.api.styles.input,
        button: this.api.styles.button,

        /**
         * Tool's classes
         */
        wrapper: "image-tool",
        imageContainer: "image-tool__image",
        imagePreloader: "image-tool__image-preloader",
        imageEl: "image-tool__image-picture",
        caption: "image-tool__caption"
      };
    }
    /**
     * Creates upload-file button
     */

  }, {
    key: "createFileButton",
    value: function createFileButton() {
      var _this$config$buttonCo,
          _this2 = this;

      var i = S("div", [this.CSS.button]);
      return i.innerHTML = (_this$config$buttonCo = this.config.buttonContent) !== null && _this$config$buttonCo !== void 0 ? _this$config$buttonCo : "".concat(L, " ").concat(this.api.i18n.t("Select an Image")), i.addEventListener("click", function () {
        _this2.onSelectFile();
      }), i;
    }
  }]);

  return D;
}();

function U(C) {
  return C && C.__esModule && Object.prototype.hasOwnProperty.call(C, "default") ? C.default : C;
}

var H = {
  exports: {}
};

(function (C, i) {
  (function (a, s) {
    C.exports = s();
  })(window, function () {
    return function (a) {
      var s = {};

      function r(o) {
        if (s[o]) return s[o].exports;
        var e = s[o] = {
          i: o,
          l: !1,
          exports: {}
        };
        return a[o].call(e.exports, e, e.exports, r), e.l = !0, e.exports;
      }

      return r.m = a, r.c = s, r.d = function (o, e, d) {
        r.o(o, e) || Object.defineProperty(o, e, {
          enumerable: !0,
          get: d
        });
      }, r.r = function (o) {
        (typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(o, "__esModule", {
          value: !0
        });
      }, r.t = function (o, e) {
        if (1 & e && (o = r(o)), 8 & e || 4 & e && _typeof(o) == "object" && o && o.__esModule) return o;
        var d = /* @__PURE__ */Object.create(null);
        if (r.r(d), Object.defineProperty(d, "default", {
          enumerable: !0,
          value: o
        }), 2 & e && typeof o != "string") for (var v in o) {
          r.d(d, v, function (l) {
            return o[l];
          }.bind(null, v));
        }
        return d;
      }, r.n = function (o) {
        var e = o && o.__esModule ? function () {
          return o.default;
        } : function () {
          return o;
        };
        return r.d(e, "a", e), e;
      }, r.o = function (o, e) {
        return Object.prototype.hasOwnProperty.call(o, e);
      }, r.p = "", r(r.s = 3);
    }([function (a, s) {
      var r;

      r = /* @__PURE__ */function () {
        return this;
      }();

      try {
        r = r || new Function("return this")();
      } catch (_unused) {
        (typeof window === "undefined" ? "undefined" : _typeof(window)) == "object" && (r = window);
      }

      a.exports = r;
    }, function (a, s, r) {
      (function (o) {
        var e = r(2),
            d = setTimeout;

        function v() {}

        function l(n) {
          if (!(this instanceof l)) throw new TypeError("Promises must be constructed via new");
          if (typeof n != "function") throw new TypeError("not a function");
          this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], t(n, this);
        }

        function f(n, c) {
          for (; n._state === 3;) {
            n = n._value;
          }

          n._state !== 0 ? (n._handled = !0, l._immediateFn(function () {
            var u = n._state === 1 ? c.onFulfilled : c.onRejected;

            if (u !== null) {
              var g;

              try {
                g = u(n._value);
              } catch (m) {
                return void y(c.promise, m);
              }

              p(c.promise, g);
            } else (n._state === 1 ? p : y)(c.promise, n._value);
          })) : n._deferreds.push(c);
        }

        function p(n, c) {
          try {
            if (c === n) throw new TypeError("A promise cannot be resolved with itself.");

            if (c && (_typeof(c) == "object" || typeof c == "function")) {
              var u = c.then;
              if (c instanceof l) return n._state = 3, n._value = c, void w(n);
              if (typeof u == "function") return void t((g = u, m = c, function () {
                g.apply(m, arguments);
              }), n);
            }

            n._state = 1, n._value = c, w(n);
          } catch (h) {
            y(n, h);
          }

          var g, m;
        }

        function y(n, c) {
          n._state = 2, n._value = c, w(n);
        }

        function w(n) {
          n._state === 2 && n._deferreds.length === 0 && l._immediateFn(function () {
            n._handled || l._unhandledRejectionFn(n._value);
          });

          for (var c = 0, u = n._deferreds.length; c < u; c++) {
            f(n, n._deferreds[c]);
          }

          n._deferreds = null;
        }

        function b(n, c, u) {
          this.onFulfilled = typeof n == "function" ? n : null, this.onRejected = typeof c == "function" ? c : null, this.promise = u;
        }

        function t(n, c) {
          var u = !1;

          try {
            n(function (g) {
              u || (u = !0, p(c, g));
            }, function (g) {
              u || (u = !0, y(c, g));
            });
          } catch (g) {
            if (u) return;
            u = !0, y(c, g);
          }
        }

        l.prototype.catch = function (n) {
          return this.then(null, n);
        }, l.prototype.then = function (n, c) {
          var u = new this.constructor(v);
          return f(this, new b(n, c, u)), u;
        }, l.prototype.finally = e.a, l.all = function (n) {
          return new l(function (c, u) {
            if (!n || n.length === void 0) throw new TypeError("Promise.all accepts an array");
            var g = Array.prototype.slice.call(n);
            if (g.length === 0) return c([]);
            var m = g.length;

            function h(T, E) {
              try {
                if (E && (_typeof(E) == "object" || typeof E == "function")) {
                  var M = E.then;
                  if (typeof M == "function") return void M.call(E, function (F) {
                    h(T, F);
                  }, u);
                }

                g[T] = E, --m == 0 && c(g);
              } catch (F) {
                u(F);
              }
            }

            for (var k = 0; k < g.length; k++) {
              h(k, g[k]);
            }
          });
        }, l.resolve = function (n) {
          return n && _typeof(n) == "object" && n.constructor === l ? n : new l(function (c) {
            c(n);
          });
        }, l.reject = function (n) {
          return new l(function (c, u) {
            u(n);
          });
        }, l.race = function (n) {
          return new l(function (c, u) {
            for (var g = 0, m = n.length; g < m; g++) {
              n[g].then(c, u);
            }
          });
        }, l._immediateFn = typeof o == "function" && function (n) {
          o(n);
        } || function (n) {
          d(n, 0);
        }, l._unhandledRejectionFn = function (n) {
          (typeof console === "undefined" ? "undefined" : _typeof(console)) < "u" && console && console.warn("Possible Unhandled Promise Rejection:", n);
        }, s.a = l;
      }).call(this, r(5).setImmediate);
    }, function (a, s, r) {
      s.a = function (o) {
        var e = this.constructor;
        return this.then(function (d) {
          return e.resolve(o()).then(function () {
            return d;
          });
        }, function (d) {
          return e.resolve(o()).then(function () {
            return e.reject(d);
          });
        });
      };
    }, function (a, s, r) {
      function o(t) {
        return (o = typeof Symbol == "function" && _typeof(Symbol.iterator) == "symbol" ? function (n) {
          return _typeof(n);
        } : function (n) {
          return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : _typeof(n);
        })(t);
      }

      r(4);
      var e,
          d,
          v,
          l,
          f,
          p,
          y,
          w = r(8),
          b = (d = function d(t) {
        return new Promise(function (n, c) {
          t = l(t), (t = f(t)).beforeSend && t.beforeSend();
          var u = window.XMLHttpRequest ? new window.XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP");
          u.open(t.method, t.url), u.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(t.headers).forEach(function (m) {
            var h = t.headers[m];
            u.setRequestHeader(m, h);
          });
          var g = t.ratio;
          u.upload.addEventListener("progress", function (m) {
            var h = Math.round(m.loaded / m.total * 100),
                k = Math.ceil(h * g / 100);
            t.progress(Math.min(k, 100));
          }, !1), u.addEventListener("progress", function (m) {
            var h = Math.round(m.loaded / m.total * 100),
                k = Math.ceil(h * (100 - g) / 100) + g;
            t.progress(Math.min(k, 100));
          }, !1), u.onreadystatechange = function () {
            if (u.readyState === 4) {
              var m = u.response;

              try {
                m = JSON.parse(m);
              } catch (_unused2) {}

              var h = w.parseHeaders(u.getAllResponseHeaders()),
                  k = {
                body: m,
                code: u.status,
                headers: h
              };
              y(u.status) ? n(k) : c(k);
            }
          }, u.send(t.data);
        });
      }, v = function v(t) {
        return t.method = "POST", d(t);
      }, l = function l() {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (t.url && typeof t.url != "string") throw new Error("Url must be a string");
        if (t.url = t.url || "", t.method && typeof t.method != "string") throw new Error("`method` must be a string or null");
        if (t.method = t.method ? t.method.toUpperCase() : "GET", t.headers && o(t.headers) !== "object") throw new Error("`headers` must be an object or null");
        if (t.headers = t.headers || {}, t.type && (typeof t.type != "string" || !Object.values(e).includes(t.type))) throw new Error("`type` must be taken from module's «contentType» library");
        if (t.progress && typeof t.progress != "function") throw new Error("`progress` must be a function or null");
        if (t.progress = t.progress || function (n) {}, t.beforeSend = t.beforeSend || function (n) {}, t.ratio && typeof t.ratio != "number") throw new Error("`ratio` must be a number");
        if (t.ratio < 0 || t.ratio > 100) throw new Error("`ratio` must be in a 0-100 interval");
        if (t.ratio = t.ratio || 90, t.accept && typeof t.accept != "string") throw new Error("`accept` must be a string with a list of allowed mime-types");
        if (t.accept = t.accept || "*/*", t.multiple && typeof t.multiple != "boolean") throw new Error("`multiple` must be a true or false");
        if (t.multiple = t.multiple || !1, t.fieldName && typeof t.fieldName != "string") throw new Error("`fieldName` must be a string");
        return t.fieldName = t.fieldName || "files", t;
      }, f = function f(t) {
        switch (t.method) {
          case "GET":
            var n = p(t.data, e.URLENCODED);
            delete t.data, t.url = /\?/.test(t.url) ? t.url + "&" + n : t.url + "?" + n;
            break;

          case "POST":
          case "PUT":
          case "DELETE":
          case "UPDATE":
            var c = function () {
              return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).type || e.JSON;
            }(t);

            (w.isFormData(t.data) || w.isFormElement(t.data)) && (c = e.FORM), t.data = p(t.data, c), c !== b.contentType.FORM && (t.headers["content-type"] = c);
        }

        return t;
      }, p = function p() {
        var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};

        switch (arguments.length > 1 ? arguments[1] : void 0) {
          case e.URLENCODED:
            return w.urlEncode(t);

          case e.JSON:
            return w.jsonEncode(t);

          case e.FORM:
            return w.formEncode(t);

          default:
            return t;
        }
      }, y = function y(t) {
        return t >= 200 && t < 300;
      }, {
        contentType: e = {
          URLENCODED: "application/x-www-form-urlencoded; charset=utf-8",
          FORM: "multipart/form-data",
          JSON: "application/json; charset=utf-8"
        },
        request: d,
        get: function get(t) {
          return t.method = "GET", d(t);
        },
        post: v,
        transport: function transport(t) {
          return t = l(t), w.selectFiles(t).then(function (n) {
            for (var c = new FormData(), u = 0; u < n.length; u++) {
              c.append(t.fieldName, n[u], n[u].name);
            }

            w.isObject(t.data) && Object.keys(t.data).forEach(function (m) {
              var h = t.data[m];
              c.append(m, h);
            });
            var g = t.beforeSend;
            return t.beforeSend = function () {
              return g(n);
            }, t.data = c, v(t);
          });
        },
        selectFiles: function selectFiles(t) {
          return delete (t = l(t)).beforeSend, w.selectFiles(t);
        }
      });
      a.exports = b;
    }, function (a, s, r) {
      r.r(s);
      var o = r(1);
      window.Promise = window.Promise || o.a;
    }, function (a, s, r) {
      (function (o) {
        var e = o !== void 0 && o || (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" && self || window,
            d = Function.prototype.apply;

        function v(l, f) {
          this._id = l, this._clearFn = f;
        }

        s.setTimeout = function () {
          return new v(d.call(setTimeout, e, arguments), clearTimeout);
        }, s.setInterval = function () {
          return new v(d.call(setInterval, e, arguments), clearInterval);
        }, s.clearTimeout = s.clearInterval = function (l) {
          l && l.close();
        }, v.prototype.unref = v.prototype.ref = function () {}, v.prototype.close = function () {
          this._clearFn.call(e, this._id);
        }, s.enroll = function (l, f) {
          clearTimeout(l._idleTimeoutId), l._idleTimeout = f;
        }, s.unenroll = function (l) {
          clearTimeout(l._idleTimeoutId), l._idleTimeout = -1;
        }, s._unrefActive = s.active = function (l) {
          clearTimeout(l._idleTimeoutId);
          var f = l._idleTimeout;
          f >= 0 && (l._idleTimeoutId = setTimeout(function () {
            l._onTimeout && l._onTimeout();
          }, f));
        }, r(6), s.setImmediate = (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" && self.setImmediate || o !== void 0 && o.setImmediate || this && this.setImmediate, s.clearImmediate = (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" && self.clearImmediate || o !== void 0 && o.clearImmediate || this && this.clearImmediate;
      }).call(this, r(0));
    }, function (a, s, r) {
      (function (o, e) {
        (function (d, v) {
          if (!d.setImmediate) {
            var l,
                f,
                p,
                y,
                w,
                b = 1,
                t = {},
                n = !1,
                c = d.document,
                u = Object.getPrototypeOf && Object.getPrototypeOf(d);
            u = u && u.setTimeout ? u : d, {}.toString.call(d.process) === "[object process]" ? l = function l(h) {
              e.nextTick(function () {
                m(h);
              });
            } : function () {
              if (d.postMessage && !d.importScripts) {
                var h = !0,
                    k = d.onmessage;
                return d.onmessage = function () {
                  h = !1;
                }, d.postMessage("", "*"), d.onmessage = k, h;
              }
            }() ? (y = "setImmediate$" + Math.random() + "$", w = function w(h) {
              h.source === d && typeof h.data == "string" && h.data.indexOf(y) === 0 && m(+h.data.slice(y.length));
            }, d.addEventListener ? d.addEventListener("message", w, !1) : d.attachEvent("onmessage", w), l = function l(h) {
              d.postMessage(y + h, "*");
            }) : d.MessageChannel ? ((p = new MessageChannel()).port1.onmessage = function (h) {
              m(h.data);
            }, l = function l(h) {
              p.port2.postMessage(h);
            }) : c && "onreadystatechange" in c.createElement("script") ? (f = c.documentElement, l = function l(h) {
              var k = c.createElement("script");
              k.onreadystatechange = function () {
                m(h), k.onreadystatechange = null, f.removeChild(k), k = null;
              }, f.appendChild(k);
            }) : l = function l(h) {
              setTimeout(m, 0, h);
            }, u.setImmediate = function (h) {
              typeof h != "function" && (h = new Function("" + h));

              for (var k = new Array(arguments.length - 1), T = 0; T < k.length; T++) {
                k[T] = arguments[T + 1];
              }

              var E = {
                callback: h,
                args: k
              };
              return t[b] = E, l(b), b++;
            }, u.clearImmediate = g;
          }

          function g(h) {
            delete t[h];
          }

          function m(h) {
            if (n) setTimeout(m, 0, h);else {
              var k = t[h];

              if (k) {
                n = !0;

                try {
                  (function (T) {
                    var E = T.callback,
                        M = T.args;

                    switch (M.length) {
                      case 0:
                        E();
                        break;

                      case 1:
                        E(M[0]);
                        break;

                      case 2:
                        E(M[0], M[1]);
                        break;

                      case 3:
                        E(M[0], M[1], M[2]);
                        break;

                      default:
                        E.apply(v, M);
                    }
                  })(k);
                } finally {
                  g(h), n = !1;
                }
              }
            }
          }
        })((typeof self === "undefined" ? "undefined" : _typeof(self)) > "u" ? o === void 0 ? this : o : self);
      }).call(this, r(0), r(7));
    }, function (a, s) {
      var r,
          o,
          e = a.exports = {};

      function d() {
        throw new Error("setTimeout has not been defined");
      }

      function v() {
        throw new Error("clearTimeout has not been defined");
      }

      function l(u) {
        if (r === setTimeout) return setTimeout(u, 0);
        if ((r === d || !r) && setTimeout) return r = setTimeout, setTimeout(u, 0);

        try {
          return r(u, 0);
        } catch (_unused3) {
          try {
            return r.call(null, u, 0);
          } catch (_unused4) {
            return r.call(this, u, 0);
          }
        }
      }

      (function () {
        try {
          r = typeof setTimeout == "function" ? setTimeout : d;
        } catch (_unused5) {
          r = d;
        }

        try {
          o = typeof clearTimeout == "function" ? clearTimeout : v;
        } catch (_unused6) {
          o = v;
        }
      })();

      var f,
          p = [],
          y = !1,
          w = -1;

      function b() {
        y && f && (y = !1, f.length ? p = f.concat(p) : w = -1, p.length && t());
      }

      function t() {
        if (!y) {
          var u = l(b);
          y = !0;

          for (var g = p.length; g;) {
            for (f = p, p = []; ++w < g;) {
              f && f[w].run();
            }

            w = -1, g = p.length;
          }

          f = null, y = !1, function (m) {
            if (o === clearTimeout) return clearTimeout(m);
            if ((o === v || !o) && clearTimeout) return o = clearTimeout, clearTimeout(m);

            try {
              o(m);
            } catch (_unused7) {
              try {
                return o.call(null, m);
              } catch (_unused8) {
                return o.call(this, m);
              }
            }
          }(u);
        }
      }

      function n(u, g) {
        this.fun = u, this.array = g;
      }

      function c() {}

      e.nextTick = function (u) {
        var g = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var m = 1; m < arguments.length; m++) {
          g[m - 1] = arguments[m];
        }
        p.push(new n(u, g)), p.length !== 1 || y || l(t);
      }, n.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.version = "", e.versions = {}, e.on = c, e.addListener = c, e.once = c, e.off = c, e.removeListener = c, e.removeAllListeners = c, e.emit = c, e.prependListener = c, e.prependOnceListener = c, e.listeners = function (u) {
        return [];
      }, e.binding = function (u) {
        throw new Error("process.binding is not supported");
      }, e.cwd = function () {
        return "/";
      }, e.chdir = function (u) {
        throw new Error("process.chdir is not supported");
      }, e.umask = function () {
        return 0;
      };
    }, function (a, s, r) {
      function o(d, v) {
        for (var l = 0; l < v.length; l++) {
          var f = v[l];
          f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(d, f.key, f);
        }
      }

      var e = r(9);

      a.exports = function () {
        function d() {
          (function (p, y) {
            if (!(p instanceof y)) throw new TypeError("Cannot call a class as a function");
          })(this, d);
        }

        var v, l, f;
        return v = d, f = [{
          key: "urlEncode",
          value: function value(p) {
            return e(p);
          }
        }, {
          key: "jsonEncode",
          value: function value(p) {
            return JSON.stringify(p);
          }
        }, {
          key: "formEncode",
          value: function value(p) {
            if (this.isFormData(p)) return p;
            if (this.isFormElement(p)) return new FormData(p);

            if (this.isObject(p)) {
              var y = new FormData();
              return Object.keys(p).forEach(function (w) {
                var b = p[w];
                y.append(w, b);
              }), y;
            }

            throw new Error("`data` must be an instance of Object, FormData or <FORM> HTMLElement");
          }
        }, {
          key: "isObject",
          value: function value(p) {
            return Object.prototype.toString.call(p) === "[object Object]";
          }
        }, {
          key: "isFormData",
          value: function value(p) {
            return p instanceof FormData;
          }
        }, {
          key: "isFormElement",
          value: function value(p) {
            return p instanceof HTMLFormElement;
          }
        }, {
          key: "selectFiles",
          value: function value() {
            var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return new Promise(function (y, w) {
              var b = document.createElement("INPUT");
              b.type = "file", p.multiple && b.setAttribute("multiple", "multiple"), p.accept && b.setAttribute("accept", p.accept), b.style.display = "none", document.body.appendChild(b), b.addEventListener("change", function (t) {
                var n = t.target.files;
                y(n), document.body.removeChild(b);
              }, !1), b.click();
            });
          }
        }, {
          key: "parseHeaders",
          value: function value(p) {
            var y = p.trim().split(/[\r\n]+/),
                w = {};
            return y.forEach(function (b) {
              var t = b.split(": "),
                  n = t.shift(),
                  c = t.join(": ");
              n && (w[n] = c);
            }), w;
          }
        }], (l = null) && o(v.prototype, l), f && o(v, f), d;
      }();
    }, function (a, s) {
      var r = function r(e) {
        return encodeURIComponent(e).replace(/[!'()*]/g, escape).replace(/%20/g, "+");
      },
          o = function o(e, d, v, l) {
        return d = d || null, v = v || "&", l = l || null, e ? function (f) {
          for (var p = new Array(), y = 0; y < f.length; y++) {
            f[y] && p.push(f[y]);
          }

          return p;
        }(Object.keys(e).map(function (f) {
          var p,
              y,
              w = f;
          if (l && (w = l + "[" + w + "]"), _typeof(e[f]) == "object" && e[f] !== null) p = o(e[f], null, v, w);else {
            d && (y = w, w = !isNaN(parseFloat(y)) && isFinite(y) ? d + Number(w) : w);
            var b = e[f];
            b = (b = (b = (b = b === !0 ? "1" : b) === !1 ? "0" : b) === 0 ? "0" : b) || "", p = r(w) + "=" + r(b);
          }
          return p;
        })).join(v).replace(/[!'()*]/g, "") : "";
      };

      a.exports = o;
    }]);
  });
})(H);

var q = H.exports;
var j = /* @__PURE__ */U(q);

function O(C) {
  return C !== void 0 && typeof C.then == "function";
}

var A = /*#__PURE__*/function () {
  /**
   * @param params - uploader module params
   * @param params.config - image tool config
   * @param params.onUpload - one callback for all uploading (file, url, d-n-d, pasting)
   * @param params.onError - callback for uploading errors
   */
  function A(_ref2) {
    var i = _ref2.config,
        a = _ref2.onUpload,
        s = _ref2.onError;

    _classCallCheck(this, A);

    this.config = i, this.onUpload = a, this.onError = s;
  }
  /**
   * Handle clicks on the upload file button
   * Fires ajax.transport()
   * @param onPreview - callback fired when preview is ready
   */


  _createClass(A, [{
    key: "uploadSelectedFile",
    value: function uploadSelectedFile(_ref3) {
      var _this$config$types2,
          _this$config$field,
          _this3 = this;

      var i = _ref3.onPreview;

      var a = function a(r) {
        var o = new FileReader();
        o.readAsDataURL(r), o.onload = function (e) {
          i(e.target.result);
        };
      };

      var s;

      if (this.config.uploader && typeof this.config.uploader.uploadByFile == "function") {
        var _this$config$types;

        var r = this.config.uploader.uploadByFile;
        s = j.selectFiles({
          accept: (_this$config$types = this.config.types) !== null && _this$config$types !== void 0 ? _this$config$types : "image/*"
        }).then(function (o) {
          a(o[0]);
          var e = r(o[0]);
          return O(e) || console.warn("Custom uploader method uploadByFile should return a Promise"), e;
        });
      } else s = j.transport({
        url: this.config.endpoints.byFile,
        data: this.config.additionalRequestData,
        accept: (_this$config$types2 = this.config.types) !== null && _this$config$types2 !== void 0 ? _this$config$types2 : "image/*",
        headers: this.config.additionalRequestHeaders,
        beforeSend: function beforeSend(r) {
          a(r[0]);
        },
        fieldName: (_this$config$field = this.config.field) !== null && _this$config$field !== void 0 ? _this$config$field : "image"
      }).then(function (r) {
        return r.body;
      });

      s.then(function (r) {
        _this3.onUpload(r);
      }).catch(function (r) {
        _this3.onError(r);
      });
    }
    /**
     * Handle clicks on the upload file button
     * Fires ajax.post()
     * @param url - image source url
     */

  }, {
    key: "uploadByUrl",
    value: function uploadByUrl(i) {
      var _this4 = this;

      var a;
      this.config.uploader && typeof this.config.uploader.uploadByUrl == "function" ? (a = this.config.uploader.uploadByUrl(i), O(a) || console.warn("Custom uploader method uploadByUrl should return a Promise")) : a = j.post({
        url: this.config.endpoints.byUrl,
        data: Object.assign({
          url: i
        }, this.config.additionalRequestData),
        type: j.contentType.JSON,
        headers: this.config.additionalRequestHeaders
      }).then(function (s) {
        return s.body;
      }), a.then(function (s) {
        _this4.onUpload(s);
      }).catch(function (s) {
        _this4.onError(s);
      });
    }
    /**
     * Handle clicks on the upload file button
     * Fires ajax.post()
     * @param file - file pasted by drag-n-drop
     * @param onPreview - file pasted by drag-n-drop
     */

  }, {
    key: "uploadByFile",
    value: function uploadByFile(i, _ref4) {
      var _this5 = this;

      var a = _ref4.onPreview;
      var s = new FileReader();
      s.readAsDataURL(i), s.onload = function (o) {
        a(o.target.result);
      };
      var r;
      if (this.config.uploader && typeof this.config.uploader.uploadByFile == "function") r = this.config.uploader.uploadByFile(i), O(r) || console.warn("Custom uploader method uploadByFile should return a Promise");else {
        var _this$config$field2;

        var o = new FormData();
        o.append((_this$config$field2 = this.config.field) !== null && _this$config$field2 !== void 0 ? _this$config$field2 : "image", i), this.config.additionalRequestData && Object.keys(this.config.additionalRequestData).length && Object.entries(this.config.additionalRequestData).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              e = _ref6[0],
              d = _ref6[1];

          o.append(e, d);
        }), r = j.post({
          url: this.config.endpoints.byFile,
          data: o,
          type: j.contentType.JSON,
          headers: this.config.additionalRequestHeaders
        }).then(function (e) {
          return e.body;
        });
      }
      r.then(function (o) {
        _this5.onUpload(o);
      }).catch(function (o) {
        _this5.onError(o);
      });
    }
  }]);

  return A;
}();
/**
 * Image Tool for the Editor.js
 * @author CodeX <team@codex.so>
 * @license MIT
 * @see {@link https://github.com/editor-js/image}
 *
 * To developers.
 * To simplify Tool structure, we split it to 4 parts:
 *  1) index.ts — main Tool's interface, public API and methods for working with data
 *  2) uploader.ts — module that has methods for sending files via AJAX: from device, by URL or File pasting
 *  3) ui.ts — module for UI manipulations: render, showing preloader, etc
 *
 * For debug purposes there is a testing server
 * that can save uploaded files and return a Response {@link UploadResponseFormat}
 *
 *       $ node dev/server.js
 *
 * It will expose 8008 port, so you can pass http://localhost:8008 with the Tools config:
 *
 * image: {
 *   class: ImageTool,
 *   config: {
 *     endpoints: {
 *       byFile: 'http://localhost:8008/uploadFile',
 *       byUrl: 'http://localhost:8008/fetchUrl',
 *     }
 *   },
 * },
 */


var P = /*#__PURE__*/function () {
  /**
   * @param tool - tool properties got from editor.js
   * @param tool.data - previously saved data
   * @param tool.config - user config for Tool
   * @param tool.api - Editor.js API
   * @param tool.readOnly - read-only mode flag
   * @param tool.block - current Block API
   */
  function P(_ref7) {
    var _a$captionPlaceholder,
        _this6 = this;

    var i = _ref7.data,
        a = _ref7.config,
        s = _ref7.api,
        r = _ref7.readOnly,
        o = _ref7.block;

    _classCallCheck(this, P);

    this.isCaptionEnabled = null, this.api = s, this.block = o, this.config = {
      endpoints: a.endpoints,
      additionalRequestData: a.additionalRequestData,
      additionalRequestHeaders: a.additionalRequestHeaders,
      field: a.field,
      types: a.types,
      captionPlaceholder: this.api.i18n.t((_a$captionPlaceholder = a.captionPlaceholder) !== null && _a$captionPlaceholder !== void 0 ? _a$captionPlaceholder : "Caption"),
      buttonContent: a.buttonContent,
      uploader: a.uploader,
      actions: a.actions,
      features: a.features || {}
    }, this.uploader = new A({
      config: this.config,
      onUpload: function onUpload(e) {
        return _this6.onUpload(e);
      },
      onError: function onError(e) {
        return _this6.uploadingFailed(e);
      }
    }), this.ui = new D({
      api: s,
      config: this.config,
      onSelectFile: function onSelectFile() {
        _this6.uploader.uploadSelectedFile({
          onPreview: function onPreview(e) {
            _this6.ui.showPreloader(e);
          }
        });
      },
      readOnly: r
    }), this._data = {
      caption: "",
      withBorder: !1,
      withBackground: !1,
      stretched: !1,
      file: {
        url: ""
      }
    }, this.data = i;
  }
  /**
   * Notify core that read-only mode is supported
   */


  _createClass(P, [{
    key: "render",
    value:
    /**
     * Renders Block content
     */
    function render() {
      var i, a, s;
      return (((i = this.config.features) == null ? void 0 : i.caption) === !0 || ((a = this.config.features) == null ? void 0 : a.caption) === void 0 || ((s = this.config.features) == null ? void 0 : s.caption) === "optional" && this.data.caption) && (this.isCaptionEnabled = !0, this.ui.applyTune("caption", !0)), this.ui.render();
    }
    /**
     * Validate data: check if Image exists
     * @param savedData — data received after saving
     * @returns false if saved data is not correct, otherwise true
     */

  }, {
    key: "validate",
    value: function validate(i) {
      return !!i.file.url;
    }
    /**
     * Return Block data
     */

  }, {
    key: "save",
    value: function save() {
      var i = this.ui.nodes.caption;
      return this._data.caption = i.innerHTML, this.data;
    }
    /**
     * Returns configuration for block tunes: add background, add border, stretch image
     * @returns TunesMenuConfig
     */

  }, {
    key: "renderSettings",
    value: function renderSettings() {
      var _this7 = this;

      var o;
      var i = P.tunes.concat(this.config.actions || []),
          a = {
        border: "withBorder",
        background: "withBackground",
        stretch: "stretched",
        caption: "caption"
      };
      ((o = this.config.features) == null ? void 0 : o.caption) === "optional" && i.push({
        name: "caption",
        icon: B,
        title: "With caption",
        toggle: !0
      });

      var s = i.filter(function (e) {
        var v, l;
        var d = Object.keys(a).find(function (f) {
          return a[f] === e.name;
        });
        return d === "caption" ? ((v = _this7.config.features) == null ? void 0 : v.caption) !== !1 : d == null || ((l = _this7.config.features) == null ? void 0 : l[d]) !== !1;
      }),
          r = function r(e) {
        var _this7$isCaptionEnabl;

        var d = _this7.data[e.name];
        return e.name === "caption" && (d = (_this7$isCaptionEnabl = _this7.isCaptionEnabled) !== null && _this7$isCaptionEnabl !== void 0 ? _this7$isCaptionEnabl : d), d;
      };

      return s.map(function (e) {
        return {
          icon: e.icon,
          label: _this7.api.i18n.t(e.title),
          name: e.name,
          toggle: e.toggle,
          isActive: r(e),
          onActivate: function onActivate() {
            var _this7$isCaptionEnabl2;

            if (typeof e.action == "function") {
              e.action(e.name);
              return;
            }

            var d = !r(e);
            e.name === "caption" && (_this7.isCaptionEnabled = !((_this7$isCaptionEnabl2 = _this7.isCaptionEnabled) !== null && _this7$isCaptionEnabl2 !== void 0 ? _this7$isCaptionEnabl2 : !1), d = _this7.isCaptionEnabled), _this7.tuneToggled(e.name, d);
          }
        };
      });
    }
    /**
     * Fires after clicks on the Toolbox Image Icon
     * Initiates click on the Select File button
     */

  }, {
    key: "appendCallback",
    value: function appendCallback() {
      this.ui.nodes.fileButton.click();
    }
    /**
     * Specify paste substitutes
     * @see {@link https://github.com/codex-team/editor.js/blob/master/docs/tools.md#paste-handling}
     */

  }, {
    key: "onPaste",
    value:
    /**
     * Specify paste handlers
     * @see {@link https://github.com/codex-team/editor.js/blob/master/docs/tools.md#paste-handling}
     * @param event - editor.js custom paste event
     *                              {@link https://github.com/codex-team/editor.js/blob/master/types/tools/paste-events.d.ts}
     */
    function () {
      var _onPaste = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(i) {
        var a, r, _a, _a2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = i.type;
                _context.next = _context.t0 === "tag" ? 3 : _context.t0 === "pattern" ? 14 : _context.t0 === "file" ? 17 : 20;
                break;

              case 3:
                a = i.detail.data;

                if (!/^blob:/.test(a.src)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 7;
                return fetch(a.src);

              case 7:
                _context.next = 9;
                return _context.sent.blob();

              case 9:
                r = _context.sent;
                this.uploadFile(r);
                return _context.abrupt("break", 20);

              case 12:
                this.uploadUrl(a.src);
                return _context.abrupt("break", 20);

              case 14:
                _a = i.detail.data;
                this.uploadUrl(_a);
                return _context.abrupt("break", 20);

              case 17:
                _a2 = i.detail.file;
                this.uploadFile(_a2);
                return _context.abrupt("break", 20);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onPaste(_x) {
        return _onPaste.apply(this, arguments);
      }

      return onPaste;
    }()
    /**
     * Private methods
     * ̿̿ ̿̿ ̿̿ ̿'̿'\̵͇̿̿\з= ( ▀ ͜͞ʖ▀) =ε/̵͇̿̿/’̿’̿ ̿ ̿̿ ̿̿ ̿̿
     */

    /**
     * Stores all Tool's data
     * @param data - data in Image Tool format
     */

  }, {
    key: "data",
    get:
    /**
     * Return Tool data
     */
    function get() {
      return this._data;
    }
    /**
     * Set new image file
     * @param file - uploaded file data
     */
    ,
    set: function set(i) {
      var _this8 = this;

      var a;
      this.image = i.file, this._data.caption = i.caption || "", this.ui.fillCaption(this._data.caption), P.tunes.forEach(function (_ref8) {
        var s = _ref8.name;
        var r = _typeof(i[s]) < "u" ? i[s] === !0 || i[s] === "true" : !1;

        _this8.setTune(s, r);
      }), i.caption ? this.setTune("caption", !0) : ((a = this.config.features) == null ? void 0 : a.caption) === !0 && this.setTune("caption", !0);
    }
  }, {
    key: "image",
    set: function set(i) {
      this._data.file = i || {
        url: ""
      }, i && i.url && this.ui.fillImage(i.url);
    }
    /**
     * File uploading callback
     * @param response - uploading server response
     */

  }, {
    key: "onUpload",
    value: function onUpload(i) {
      i.success && i.file ? this.image = i.file : this.uploadingFailed("incorrect response: " + JSON.stringify(i));
    }
    /**
     * Handle uploader errors
     * @param errorText - uploading error info
     */

  }, {
    key: "uploadingFailed",
    value: function uploadingFailed(i) {
      console.log("Image Tool: uploading failed because of", i), this.api.notifier.show({
        message: this.api.i18n.t("Couldn’t upload image. Please try another."),
        style: "error"
      }), this.ui.hidePreloader();
    }
    /**
     * Callback fired when Block Tune is activated
     * @param tuneName - tune that has been clicked
     * @param state - new state
     */

  }, {
    key: "tuneToggled",
    value: function tuneToggled(i, a) {
      i === "caption" ? (this.ui.applyTune(i, a), a == !1 && (this._data.caption = "", this.ui.fillCaption(""))) : this.setTune(i, a);
    }
    /**
     * Set one tune
     * @param tuneName - {@link Tunes.tunes}
     * @param value - tune state
     */

  }, {
    key: "setTune",
    value: function setTune(i, a) {
      var _this9 = this;

      this._data[i] = a, this.ui.applyTune(i, a), i === "stretched" && Promise.resolve().then(function () {
        _this9.block.stretched = a;
      }).catch(function (s) {
        console.error(s);
      });
    }
    /**
     * Show preloader and upload image file
     * @param file - file that is currently uploading (from paste)
     */

  }, {
    key: "uploadFile",
    value: function uploadFile(i) {
      var _this10 = this;

      this.uploader.uploadByFile(i, {
        onPreview: function onPreview(a) {
          _this10.ui.showPreloader(a);
        }
      });
    }
    /**
     * Show preloader and upload image by target url
     * @param url - url pasted
     */

  }, {
    key: "uploadUrl",
    value: function uploadUrl(i) {
      this.ui.showPreloader(i), this.uploader.uploadByUrl(i);
    }
  }], [{
    key: "isReadOnlySupported",
    get: function get() {
      return !0;
    }
    /**
     * Get Tool toolbox settings
     * icon - Tool icon's SVG
     * title - title to show in toolbox
     */

  }, {
    key: "toolbox",
    get: function get() {
      return {
        icon: L,
        title: "Image"
      };
    }
    /**
     * Available image tools
     */

  }, {
    key: "tunes",
    get: function get() {
      return [{
        name: "withBorder",
        icon: I,
        title: "With border",
        toggle: !0
      }, {
        name: "stretched",
        icon: x,
        title: "Stretch image",
        toggle: !0
      }, {
        name: "withBackground",
        icon: R,
        title: "With background",
        toggle: !0
      }];
    }
  }, {
    key: "pasteConfig",
    get: function get() {
      return {
        /**
         * Paste HTML into Editor
         */
        tags: [{
          img: {
            src: !0
          }
        }],

        /**
         * Paste URL of image into the Editor
         */
        patterns: {
          image: /https?:\/\/\S+\.(gif|jpe?g|tiff|png|svg|webp)(\?[a-z0-9=]*)?$/i
        },

        /**
         * Drag n drop file from into the Editor
         */
        files: {
          mimeTypes: ["image/*"]
        }
      };
    }
  }]);

  return P;
}();

export { P as default };